<template>
  <div>
    <template v-if=" getJob(this.jobId) &&   getInstructionByJobId(this.jobId).length">
      <portlet
          :icon="'fad fa-book'"
          :title="$tc('instructionsViewer.title', getInstructionByJobId(this.jobId).length) + (extraTitleInfo ? ` (${extraTitleInfo})` : '')"
          :actions-block="false"
          :fullheight="true"
          class="portlet-pt-20 "
      >
        <template slot="portletBody">
          <div class="container-fluid">
            <div class="instructions-wrapper">
              <div class="instructions">
                <div class="instruction" v-bind:key="instruction.id"
                     v-for="instruction in getInstructionByJobId(this.jobId)">
                  <div v-if="getConfig.publications && hasPublication(instruction.id)" class="publication-badge" @click="openPublicationModal(instruction)">
                    <i class="fas fa-exclamation-circle"></i> {{ $t('publications.readAndUnderstood') }}
                  </div>
                  <div class="file" v-bind:key="file.fullPath" v-for="file in instruction.files" @click="activeFile = file"
                       :active="getActiveFile === file">
                    <div class="row file-content">
                      <div>
                        <i class="file-icon fas" :class="getFontAwesomeIcon(file.type)"></i>
                      </div>
                      <div>
                        <div class="instruction-title" :title="instruction.title">{{ instruction.title }}</div>
                        <div class="file-name" :title="file.name">{{ file.name }}</div>
                      </div>
                    </div>
                    <div class="info-button" :active="getActiveFile === file"
                         @click="showDescription($event, instruction, file)">
                      <i class="info-circle fas fa-info-circle"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="file-viewer-wrapper">
                <FileViewer v-if="getActiveFile" :file="getActiveFile">

                </FileViewer>
              </div>
            </div>
          </div>

        </template>

      </portlet>

    </template>

    <InstructionPublicationViewer
      v-if="getConfig.publications"
      ref="publicationViewer"
      :modalId="'instructionPublicationAcknowledgement'"
    />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import mimetypes from "font-awesome-filetypes/lib/mimetypes";
import FileViewer from "@/components/filemanager/FileViewer";
import InstructionPublicationViewer from "@/components/publications/InstructionPublicationViewer.vue";

export default {
  name: "InstructionsViewer",
  props: ['jobId', 'extraTitleInfo'],
  components: {FileViewer, InstructionPublicationViewer},
  data() {
    return {
      activeFile: null
    }
  },
  computed: {
    ...mapGetters('jobs', ['getJob']),
    ...mapGetters('instructions', ['getInstructionByJobId']),
    ...mapGetters('users', ['getSelectedWorkflow']),
    ...mapGetters('company', ['getConfig']),
    getFontAwesomeIcon: () => (mimetype) => {
      return mimetypes[mimetype];
    },
    getActiveFile() {
      return this.activeFile ? this.activeFile : _.first(_.first(this.getInstructionByJobId(this.jobId)).files);
    },
  },
  methods: {
    showDescription($event, instruction, file) {
      const html = `
      <div>
        <div style="margin-bottom: 1rem;">
            <sub>${file.name}</sub>
       </div>
       <div>${instruction.description ? instruction.description : ''}</div>
      </div>
      `;

      $event.stopPropagation();
      return this.$swal({
        title: instruction.title,
        html,
        confirmButtonText: this.$t('ui.ok'),
        showCancelButton: false,
      });
    },
    openPublicationModal(instruction) {
      this.$refs.publicationViewer.open(instruction)
    },
    hasPublication(instructionId) {
      return this.getConfig.publications && this.$refs.publicationViewer && this.$refs.publicationViewer.hasPublication(instructionId)
    }
  },
  async  created() {
    await this.$store.dispatch("jobs/fetchById", this.jobId);
    await this.$store.dispatch('instructions/fetchAndAddByJobId', this.jobId)
  },
  watch: {
    'getSelectedWorkflow': {
      handler() {
        // If the selected workflow changes => the db channel needs to open again to fetch instructions assigned to that workflow
        this.$store.dispatch('instructions/fetchAndAddByJobId', this.jobId);
        // also reset the active file to null => because switching a workflow could hide the current file
        this.activeFile = null;
      }
    }
  }
}
</script>

<style scoped>

.instructions {
  display: grid;
  grid-auto-columns: min-content;
  grid-auto-flow: row;
  margin-bottom: 2rem;
  overflow: auto;
  grid-auto-rows: min-content;
  grid-row-gap: 1rem;
}

.file[active='true'] {
  border: 1px solid #00C9FF;
  background-color: #cff3ff;
  color: #023441
}

.file {
  border: 1px solid #cbcbcb;
  background-color: whitesmoke;
  margin-right: 1rem;
  cursor: pointer;
  width: 25rem;
  display: grid;
  grid-auto-columns: auto 4rem;
  grid-auto-flow: column;
}

.file-content {
  display: grid;
  align-items: center;
  grid-auto-columns: 4rem auto;
  grid-auto-flow: column;
  height: 100%;
  margin-left: 1rem;
  margin-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-icon {
  font-size: 3rem;
}

.info-circle {
  font-size: 2rem;
}

.instruction-title {
  font-weight: bold;
}

.file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.2rem;
  font-weight: 300;
  width: 14rem;
}


.info-button[active='true'] {
  border-left: 1px solid #00C9FF;
}

.info-button {
  text-align: center;
  height: 100%;
  display: grid;
  align-items: center;
  border-left: 1px solid #cbcbcb;
}

.file-viewer-wrapper {
  margin-bottom: 2rem;
  height: 90vh;
  max-height: 90vh;
}

.instructions-wrapper {
  display: grid;
  grid-template-columns: 26rem 1fr;
}

.publication-badge {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.2rem;
  width: 25rem;
  margin-bottom: 0.5rem;
}

.publication-badge:hover {
  background-color: #ffe69c;
}
</style>